<div class="wrapper"
	[ngClass]="{'only-visible-column': (visible && visibleColumns === 1), 'dark-theme': theme === 'darkTheme', 'socials-theme': theme === 'socials-theme'}"
	(mouseenter)="mouseenter()" [attr.title]="titleValue ? titleValue : null">
	<ng-content></ng-content>
</div>
